export default __webpack_public_path__ + "static/7-0cbc9cb496ec82e30cffebbc76b5e0d3.png";